// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2K1wY","emails":"CreateEditClinics_emails__1Fhtc","emailTagLabel":"CreateEditClinics_emailTagLabel__NLRhy"};